export default __webpack_public_path__ + "static/media/searchPlus.8c3886c1.svg";